module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-vector-098afd942461c40b7f1032140835ed40.png";